import CreateNote from './CreateNoteTemplate';

export default CreateNote;
